import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-add",
  "use": "icon-mobile-add-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-add\">\n    <path d=\"M8.5 2v5.499L14 7.5l-1 1-4.501-.001L8.5 14h-1l-.001-5.501L2 8.5v-1l5.5-.001V2h1zm0 4.5-1 1h1v-1z\" fill=\"#FFF\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol